import { SearchBox } from '@/components/search/SearchBox';
import { CategoryQuickChips } from '@/components/places/CategoryQuickChips';
import { Logo } from '@/components/ui/Logo';

/**
 * Top-left dashboard chrome: brand + search + category quick-access chips.
 * Anchors the primary interactions into one cohesive surface above the map.
 */
export function DashboardHeader() {
  return (
    <div className="absolute left-3 top-3 z-panel flex w-[calc(100vw-5rem)] max-w-md flex-col gap-2 sm:left-4 sm:top-4">
      {/* Brand */}
      <div className="flex w-fit items-center rounded-full bg-white/95 px-3 py-1.5 shadow-card backdrop-blur">
        <Logo size={22} />
      </div>

      {/* Search */}
      <SearchBox />

      {/* Category quick-access */}
      <CategoryQuickChips />
    </div>
  );
}
